import { LOCAL_STORAGE_KEY, SESSION_STORAGE_KEY } from 'define';

const firstEntryPoint = window.localStorage.getItem(LOCAL_STORAGE_KEY);
const sessionSiteEntryPoint = window.sessionStorage.getItem(SESSION_STORAGE_KEY);

function entryPointVerification(storage, entryPoint, key) {
  if (!entryPoint) {
    storage.setItem(key, window.location.href);
  }
}

entryPointVerification(localStorage, firstEntryPoint, LOCAL_STORAGE_KEY);
entryPointVerification(sessionStorage, sessionSiteEntryPoint, SESSION_STORAGE_KEY);
